/**
 * @desc 获取用户登录首页
 */
const URL = "/rantion-ucenter";
import http, { updateResponse } from "@/http";
export function request(userNo: string | number, options?: any) {
  return updateResponse(
    http(URL + `/sysUserData/getUserHomePage/${userNo}`, {
      method: "GET",

      ...options,
    }),
  );
}
